import styled from "@emotion/styled";
import { Ui, interactiveText } from "@silvertours/front-shared";
import Comment from "@engineering/icons/comment";
import { HeaderIconStyles } from "../Header.styles";
var PhoneInfoPopoverWrapper = /*#__PURE__*/ styled("div", {
    target: "ezm1i8k0"
})("display:flex;align-items:center;");
var PhoneNumberWrapperSection = /*#__PURE__*/ styled("div", {
    target: "ezm1i8k1"
})(function(param) {
    var theme = param.theme;
    return interactiveText({
        textColor: "grey",
        theme: theme
    });
}, ";");
var PhoneNumber = /*#__PURE__*/ styled(Ui.PhoneNumber, {
    target: "ezm1i8k2"
})("color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";display:none;", function(param) {
    var phoneNumber = param.phoneNumber;
    return phoneNumber && "gap: 0.5rem;";
}, " ", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:flex;white-space:nowrap;}");
var ContactIcon = /*#__PURE__*/ styled(Comment, {
    target: "ezm1i8k3"
})(HeaderIconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";min-width:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
export { ContactIcon, PhoneInfoPopoverWrapper, PhoneNumber, PhoneNumberWrapperSection };
